import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useTaboolaBusinessManagerStore = defineStore({
  id: 'taboolaBusinessManagerStore',
  state: () => ({
    taboolaBusinessManagers: [],
    taboolaBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getTaboolaBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.taboolaBusinessManagersLoading = true

      try {
        const {data} = await axios.get('taboola/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.taboolaBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.taboolaBusinessManagersLoading = false
      }
    },
  },
})
